import React from "react";
import { Link } from "react-router-dom";
import { GemButtons } from "@/components/BirthstoneFinder";

const COLS: Record<string, string> = { "1": "max-w-[1000px]", "2": "sm:grid-cols-2 max-w-[1000px]", "3": "sm:grid-cols-2 md:grid-cols-3 max-w-[1300px]", "4": "grid-cols-2 md:grid-cols-4 max-w-[1400px] !gap-5 md:!gap-10" };
const SHAPE: Record<string, string> = { portrait: "aspect-[4/5]", square: "aspect-square", landscape: "aspect-[3/2]" };

export function Gallery({ b }: any) {
  const items = (b.items || []).filter((x: any) => x.image);
  if (!items.length) return null;
  return (
    <section className={`mx-auto px-5 md:px-12 pb-14 md:pb-20 grid grid-cols-1 gap-8 md:gap-10 ${COLS[b.columns] || COLS["3"]}`} data-testid="gallery-block">
      {items.map((x: any, i: number) => (
        <figure key={i} data-testid={`gallery-item-${i}`}>
          {x.link_url ? (
            <Link to={x.link_url} className="block overflow-hidden group" data-testid={`gallery-image-link-${i}`}><img src={x.image} alt={x.title || x.caption || ""} loading="lazy" className={`w-full object-cover bg-neutral-100 transition-transform duration-700 group-hover:scale-[1.04] ${SHAPE[b.shape] || SHAPE.portrait}`} /></Link>
          ) : <img src={x.image} alt={x.title || x.caption || ""} loading="lazy" className={`w-full object-cover bg-neutral-100 ${SHAPE[b.shape] || SHAPE.portrait}`} />}
          {x.title && <p className="mt-4 font-display text-xl">{x.title}</p>}
          {x.caption && <figcaption className={`${x.title ? "mt-2" : "mt-3"} text-sm text-neutral-600 leading-relaxed`}>{x.caption}</figcaption>}
          {x.gem && <div className="mt-5"><GemButtons gem={x.gem} /></div>}
          {x.link_url && <Link to={x.link_url} className="mt-2 inline-block text-sm underline underline-offset-4 hover:text-[var(--c-primary)]" data-testid={`gallery-link-${i}`}>{x.link_label || "Learn more"}</Link>}
        </figure>
      ))}
    </section>
  );
}
